var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuicksight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 577,
    height: 577,
    viewBox: "0 0 577 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7730_18528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.725 129.825L288.5 375.05V173.1L43.275 418.325V43.275H533.725M25.1861 0C18.5277 0.0452092 12.1543 2.70733 7.44203 7.41153C2.72973 12.1157 0.0566594 18.4845 0 25.1428L0 551.8C0.0577 565.648 11.3525 576.928 25.1428 577H551.8C558.457 576.955 564.829 574.295 569.544 569.595C574.258 564.894 576.936 558.529 577 551.872V25.1861C576.951 18.5289 574.288 12.1576 569.584 7.44614C564.881 2.73464 558.514 0.0603759 551.857 0L25.1861 0Z",
    fill: "#63C0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7730_18528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 577,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicksight);
export default __webpack_public_path__ + "static/media/quicksight.a3ade815773c203892cf4eb2a5a09bdd.svg";
export { ForwardRef as ReactComponent };